import domify from 'domify';
import page from 'modules/ab-page-js';
import container from 'modules/section-content';
import Batch from 'batch';
import rg from 'modules/npm-component/require-global';
import jquerysf from './events-page-jquerysf.pug';
import angularu from './events-page-angularu.pug';
import cascadia from './events-page-cascadia.pug';
import oscon from './events-page-oscon.pug';
import forward from './events-page-forward.pug';
import fec15 from './events-page-fec15.pug';
import {
  jquerysfMeta,
  angularuMeta,
  cascadiaMeta,
  osconMeta,
  forwardMeta,
  fec15Meta
} from './events-meta';

export default function register() {
  page('/events/jquerysf-angular-2', render(jquerysf, jquerysfMeta), loadScripts);
  page(
    '/events/angularu-single-page-app-authentication',
    render(angularu, angularuMeta),
    loadScripts
  );
  page(
    '/events/cascadia-client-side-jwt-authentication',
    render(cascadia, cascadiaMeta),
    loadScripts
  );
  page('/events/oscon-reactive-frontend', render(oscon, osconMeta), loadScripts);
  page('/events/forwardjs-reactive-frontend', render(forward, forwardMeta), loadScripts);
  page('/events/fec15-webtask', render(fec15, fec15Meta), loadScripts);
}

function render(layout, metadata) {
  return (ctx, next) => {
    const renderOptions = {
      metadata,
      // Only pass view on client render.
      ...(ctx.init ? {} : { view: domify(layout()) })
    };
    container.render(renderOptions);

    next();
  };
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.end(next);
}



// WEBPACK FOOTER //
// ./src/pages/events-landing/events.js